module.exports = "/static/media/android.c55dec11.svg";